<template>
	<BaseCmsPage v-slot="{page}">
		<ClientOnly>
			<BaseAuthUser v-slot="{user, urls, currentUrl}">
				<CmsIntroContainer :page="page" mode="auth">
					<template #h1>
						<h1 v-if="user?.first_name && page?.title"><BaseCmsLabel code="welcome" /> {{user.first_name}}</h1>
					</template>
				</CmsIntroContainer>
				<AuthMainLayout>
					<template #authContent>
						<div class="clear a-intro">
							<div class="a-intro-left">
								<BaseCmsLabel code="you_can" class="a-intro-menu-title" tag="p" />
								<ul class="a-menu">
									<li><NuxtLink :to="urls.auth_my_webshoporder" :class="{'active': urls.auth_my_webshoporder == currentUrl}"><BaseCmsLabel code="auth_view_orders" tag="span" /></NuxtLink></li>
									<li><NuxtLink :to="urls.auth+'#coupons'" :class="{'active': urls.auth_my_webshopcoupon == currentUrl}"><BaseCmsLabel code="auth_view_coupons" tag="span" /></NuxtLink></li>
									<li><NuxtLink :to="urls.auth_edit" :class="{'active': urls.auth_edit == currentUrl}"><BaseCmsLabel code="auth_edit_profile" tag="span" /></NuxtLink></li>
									<li><NuxtLink :to="urls.auth_change_password" :class="{'active': urls.auth_change_password == currentUrl}"><BaseCmsLabel code="auth_change_password" tag="span" /></NuxtLink></li>
									<li><NuxtLink :to="urls.auth_logout+'?redirect=/'"><BaseCmsLabel code="auth_logout" tag="span" /></NuxtLink></li>
								</ul>
							</div>
							<div class="a-intro-user">
								<div class="a-intro-title" v-if="user?.first_name && user?.last_name">{{user.first_name}} {{user.last_name}}</div>
								<span class="a-intro-email" v-if="user?.email">{{user.email}}</span>
								<span class="a-intro-tel" v-if="user?.phone">{{user.phone}}</span>
								<template v-if="user?.address">
									<p class="a-intro-address">
										{{user.address}}<br>
										{{user.zipcode}}<br>
										{{user.city}}
									</p>
								</template>
								<NuxtLink class="btn-auth-edit" :to="urls.auth_edit" :class="{'active': urls.auth_edit == currentUrl}"><BaseCmsLabel code="edit_profile" /></NuxtLink>
							</div>
						</div>

						<BaseAuthOrders v-slot="{items: orders}">
							<template v-if="orders?.length">
								<div class="auth-box orders-container" id="orders">
									<h2 class="a-section-title"><NuxtLink :to="urls.auth_my_webshoporder"><BaseCmsLabel code="latest_orders" tag="span" /></NuxtLink></h2>
									<AuthWebshopOrders :orders="orders" mode="dashboard" />
								</div>
								<div class="see-all-orders">
									<NuxtLink class="btn btn-primary see-all-orders-btn" :to="urls.auth_my_webshoporder"><BaseCmsLabel code="all_webshoporder" tag="span" /></NuxtLink>
								</div>
							</template>
						</BaseAuthOrders>

						<BaseAuthCoupons v-slot="{items}">
						<div class="auth-box auth-box-coupons" id="coupons">
							<BaseCmsLabel code="coupon_dashboard_title" class="a-section-title a-section-coupons-title" tag="h2" />
							
							<div class="a-section-coupons-cnt">
								<WebshopCouponForm mode="auth" />
								<WebshopCouponList :coupons="items" />
							</div>
						</div>
						</BaseAuthCoupons>
					</template>
				</AuthMainLayout>
			</BaseAuthUser>
			<template #fallback>
				<BaseThemeUiLoading />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
</style>
